export default {
  'pages.applicationFeedback.factoryIssue': '軟體工廠事項',
  'pages.applicationFeedback.factoryIssueNotAdded': '尚未新增為事項',
  'pages.applicationFeedback.factoryIssueAdding': '新增中',
  'pages.applicationFeedback.factoryIssueFailed': '新增失敗',
  'pages.applicationFeedback.factoryIssuePartiallyAdded':
    '事項已建立，關聯未完成',
  'pages.applicationFeedback.factoryIssueDeleted': '關聯事項已刪除',
  'pages.applicationFeedback.readdToSoftwareFactory': '重新新增至軟體工廠',
  'pages.applicationFeedback.factoryIssueId': '事項識別碼',

  'pages.applicationFeedback.organizationFilter': '篩選組織',
  'pages.applicationFeedback.retrySoftwareFactory': '重試新增至軟體工廠',
  'pages.applicationFeedback.title': '應用回饋',
  'pages.applicationFeedback.feedback': '回饋內容',
  'pages.applicationFeedback.searchPlaceholder': '搜尋標題或內容',
  'pages.applicationFeedback.type': '回饋類型',
  'pages.applicationFeedback.status': '處理狀態',
  'pages.applicationFeedback.priority': '優先級',
  'pages.applicationFeedback.application': '應用',
  'pages.applicationFeedback.applications': '應用列表',
  'pages.applicationFeedback.allFeedback': '全部回饋',
  'pages.applicationFeedback.pluginApplication': '插件應用',
  'pages.applicationFeedback.pcApplication': 'PC 普通應用',
  'pages.applicationFeedback.searchApplications': '搜尋應用名稱或標識',
  'pages.applicationFeedback.refreshApplications': '重新整理應用列表',
  'pages.applicationFeedback.noApplications': '暫無有回饋紀錄的應用',
  'pages.applicationFeedback.noFeedback': '暫無回饋',
  'pages.applicationFeedback.applicationsUnavailable': '無法載入應用列表',
  'pages.applicationFeedback.unknownApplication': '未關聯應用',
  'pages.applicationFeedback.unknownName': '未知',
  'pages.applicationFeedback.unknownSubmitter': '未知提交人',
  'pages.applicationFeedback.tenant': '租戶',
  'pages.applicationFeedback.tenantFilter': '篩選租戶',
  'pages.applicationFeedback.submitter': '提交人',
  'pages.applicationFeedback.operator': '平台處理人',
  'pages.applicationFeedback.createdAt': '提交時間',
  'pages.applicationFeedback.lastActivity': '最近更新',
  'pages.applicationFeedback.contact': '聯絡方式',
  'pages.applicationFeedback.pageUrl': '回饋頁面',
  'pages.applicationFeedback.viewScreenshot': '查看截圖',
  'pages.applicationFeedback.attachments': '附件',
  'pages.applicationFeedback.previewAttachment': '預覽附件',
  'pages.applicationFeedback.downloadAttachment': '下載附件',
  'pages.applicationFeedback.popupBlocked':
    '瀏覽器封鎖了附件頁面，請允許彈出視窗後重試',
  'pages.applicationFeedback.actions': '操作',
  'pages.applicationFeedback.detail': '詳情',
  'pages.applicationFeedback.addToSoftwareFactory': '新增至軟體工廠',
  'pages.applicationFeedback.addedToSoftwareFactory': '已新增至軟體工廠',
  'pages.applicationFeedback.addToSoftwareFactorySuccess': '已新增至軟體工廠',
  'pages.applicationFeedback.softwareFactoryProjectMissing':
    '暫無專案資訊，無法建立事項',
  'pages.applicationFeedback.replies': '回覆記錄',
  'pages.applicationFeedback.activity': '處理記錄',
  'pages.applicationFeedback.noReplies': '暫無回覆',
  'pages.applicationFeedback.replyPlaceholder': '輸入回覆內容',
  'pages.applicationFeedback.replyRequired': '請輸入回覆內容',
  'pages.applicationFeedback.sendReply': '傳送回覆',
  'pages.applicationFeedback.replySuccess': '回覆已傳送',
  'pages.applicationFeedback.updateSuccess': '已更新回饋',
  'pages.applicationFeedback.refresh': '重新整理',
  'pages.applicationFeedback.empty': '暫無應用回饋',
  'pages.applicationFeedback.totalCount': '共 {count} 條',
  'pages.applicationFeedback.detailUnavailable': '無法載入回饋詳情',
  'pages.applicationFeedback.type.bug': '問題回報',
  'pages.applicationFeedback.type.feature': '功能建議',
  'pages.applicationFeedback.type.optimization': '體驗優化',
  'pages.applicationFeedback.type.other': '其他',
  'pages.applicationFeedback.status.pending': '待處理',
  'pages.applicationFeedback.status.processing': '處理中',
  'pages.applicationFeedback.status.resolved': '已解決',
  'pages.applicationFeedback.status.closed': '已關閉',
  'pages.applicationFeedback.status.withdrawn': '已撤回',
  'pages.applicationFeedback.priority.low': '低',
  'pages.applicationFeedback.priority.medium': '中',
  'pages.applicationFeedback.priority.high': '高',
};
